// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2b5540f2","503":"e2e37f31","559":"396ca927","733":"80b8ab95","880":"cb3d1f6d"}[chunkId] + ".chunk.js";
};